module.exports = __webpack_public_path__ + "img/VIDRIO_RECURRENTE.png";